import { Helmet } from "react-helmet-async";
import React, { useContext } from "react";
import { MetadataContext } from "../Contexts/MetadataContext";
import { useLocation } from "react-router-dom";
import { getPageTypeId } from "../Utils/pageMap";

export default function Meta() {
  const { metadata, loading } = useContext(MetadataContext);
  const location = useLocation();

  const pageTypeId = getPageTypeId(location.pathname);

  if (loading) return null;

  const metaArray = metadata ? Object.values(metadata) : [];

  const meta =  metaArray.find(m => m.Page === pageTypeId) || {
    Title: "Play MegaStore",
    Description: "Shop the latest laptops, smartphones, electronics, and accessories at unbeatable prices. Fast delivery, secure checkout, and top brands — all in one place at Play MegaStore.",
    Keywords: "laptops, smartphones, electronics, accessories, Play MegaStore, buy laptop online, buy phone online, gaming laptops, mobile accessories",
    Url: window.location.href,
    Type: "website",
    Image: "",
    TwitterCard: "summary_large_image",
  };

  // pages of the customer account / checkout flow should not appear in search results
  const privatePages = ["/Cart", "/Checkout", "/Profile", "/WishList", "/UserAuthentication", "/Forget-Password", "/Reset-Password", "/Email-Confirmation", "/Order-Tracking", "/ThankYouPopUp"];
  const isPrivate = privatePages.some((page) => location.pathname === page || location.pathname.startsWith(page + "/"));
  const canonicalUrl = window.location.origin + location.pathname;

  return (
    <Helmet>
      <title>{meta.Title}</title>
      <link rel="canonical" href={canonicalUrl} />
      {isPrivate && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:site_name" content="Play MegaStore" />
      <meta name="title" content={meta.Title} />
      <meta name="description" content={meta.Description} />
      <meta name="keywords" content={meta.Keywords} />

      {/* Open Graph */}
      <meta property="og:title" content={meta.Title} />
      <meta property="og:description" content={meta.Description} />
      <meta property="og:type" content={meta.Type} />
      <meta property="og:url" content={meta.Url} />
      <meta property="og:image" content={meta.Image} />

      {/* Twitter Card */}
      <meta name="twitter:card" content={meta.TwitterCard} />
      <meta name="twitter:title" content={meta.Title} />
      <meta name="twitter:description" content={meta.Description} />
      <meta name="twitter:image" content={meta.Image} />
    </Helmet>
  );
}
